import React, { ReactElement, ReactNode } from 'react';
import { DataCollectionValuesKey } from '../../../hooks';

interface CheckCardProps {
    children?: ReactNode;
    customClassName?: string;
    name: DataCollectionValuesKey;
    value: string;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    checked?: boolean;
    check?: boolean;
    img?: string;
    bigImg?: boolean;
    title?: string;
    titleSecond?: string;
    description?: string;
}

const CheckCard = ({
    children,
    customClassName,
    name,
    value,
    checked,
    onChange,
    check = true,
    img,
    bigImg,
    title,
    titleSecond,
    description,
}: CheckCardProps): ReactElement<'div'> | null => {
    return (
        <label
            className={`check-card ${customClassName ? customClassName : ''} ${
                bigImg && img ? 'check-card--image-big' : ''
            }`}
        >
            <input
                className={'check-card__input'}
                type="radio"
                name={name}
                value={value}
                onChange={onChange}
                checked={checked}
            />
            <div className={'check-card__body'}>
                {check && (
                    <div className={'check-card__check'}>
                        <img src="/img/icon/check-circle.svg" alt="checked" />
                    </div>
                )}

                {children}

                {!children && (
                    <div className={'check-card__inner'}>
                        {img && (
                            <div className={`check-card__image`}>
                                <img src={img} alt={title} />
                            </div>
                        )}
                        <div className="check-card__text">
                            {title && <h3 className="check-card__title">{title}</h3>}
                            {titleSecond && <h3 className="check-card__title check-card__title--second">{titleSecond}</h3>}
                            {description && <p className="check-card__desc">{description}</p>}
                        </div>
                    </div>
                )}
            </div>
        </label>
    );
};

export default CheckCard;
